import React from "react";
import { 
    Button, 
    Dialog, 
    DialogContent, 
    DialogContentText, 
    TextField, 
    DialogActions, 
    Chip 
} from '@mui/material';
import axios from "axios";

class UserPosts extends React.Component {
    // constructor fxn to initialize component state and bind event handlers
    constructor(props) {
        // call parent class contructor to initialize react component
        super(props);
        // state variables to manage visibility of input field and post string
        this.state = {
            // hold user post
            post: "",
        };

        // binding event handlers
        // update post state as user types
        this.post_made = this.post_made.bind(this);
        // submit post handler
        this.post_submission = this.post_submission.bind(this);
    };

    // update post state with text input made by user
    post_made(event) {
        // get text from input field
        const post_input = event.target.value;
        this.setState({
            post: post_input
        });
    }

    // handle post submission to the backend
    post_submission() {
        // extract post from state
        const { post } = this.state;

        // send user's writing post data to backend using axios via POST request ('/user/post' from backend POST endpoint in webServer.js)
        axios.post('/user/posts', {content: post})
            .then((response) => {
                // close dialog and clear input
                this.props.onClose();

                // reset post input field
                this.setState({
                    post: ""
                });
            })
            .catch((error) => {
                // handle error with a message 
                console.error("Error submitting post:", error);
        });
    }

    // render input field for user to write post
    render() {
        // extract the two props returned from ProfilePage
        const { open, onClose } = this.props; 

        return (
            <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
                <DialogContent>
                    <DialogContentText>
                        Write
                    </DialogContentText>
                    <TextField
                        autoFocus
                        margin="dense"
                        label="Your Post"
                        type="text"
                        fullWidth
                        multiline
                        minRows={4}
                        value={this.state.post}
                        onChange={this.post_made}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose}>Cancel</Button>
                    <Button variant="contained" onClick={this.post_submission}>
                        Post
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

export default UserPosts